import * as React from 'react';
import { LoadingComponent } from '../LoadingComponent/LoadingComponent';

type Props = {
    element: React.ReactElement;
};

const LazyLoadingWrapper = ({ element }: Props) => {
    return <React.Suspense fallback={<LoadingComponent isLoading />}>{element}</React.Suspense>;
};

export default LazyLoadingWrapper;
